import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar"; // Adjust the import path
import Header from "./Header"; // Adjust the import path
import { useLanguage } from "../../LanguageContext"; // Adjust the import path
import Header2 from "./Header2";
/*import { useDispatch } from "react-redux";
import { getNotificationsService } from "redux/services/general_service";*/

const Layout = ({ children, isOpen, onClose }) => {
  const [pageTitle, setPageTitle] = useState("Dashboard");

  const { direction } = useLanguage(); // Get the current direction from context

  /*const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNotificationsService());
  }, []);*/

  return (
    <main className="flex flex-row w-full min-h-screen bg-background-main">
      {/* Sidebar */}
      <div className="hidden lg:block">
        <Sidebar setPageTitle={setPageTitle} />
      </div>

      <div className="flex flex-col w-full lg:w-[82%] gap-5">
        <Header2 pageTitle={pageTitle} />
        {children}
      </div>
    </main>
  );
  /* <div
      className={`flex ${
        direction === "rtl" ? "flex-row-reverse" : "flex-row"
      }`}
    >
      <Sidebar isOpen={isOpen} onClose={onClose} />
      <div
        className={`flex-1 flex flex-col ${
          direction === "rtl" ? "mr-0 lg:mr-64" : "ml-0 lg:ml-64"
        }`}
      >
        <Header onMenuClick={onClose} />
        <main className="flex-1 p-4">{children}</main>
      </div>
    </div>*/
};

export default Layout;
